module.exports = __webpack_public_path__ + "p1_img2.jpg?f3a66554b3bb7eedb353694e5820350c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p1/p1_img2.jpg
// module id = 99
// module chunks = 0